<script lang="ts">
  import { type BlockProps } from "../Block.svelte";
  import { clsx } from "clsx";

  export let text: string = "";
  export let style: StatmicValue = "";
  export let color: string = "";
  export let id: string = "";
  export let type: "styled_text" = "styled_text";

  const styles = {
    "prose-lg": "prose-lg",
    "wah-hero-1": "[&>*]:wah-hero-1",
    "wah-hero-2": "[&>*]:wah-hero-2",
    "wah-heading-1": "[&>*]:wah-heading-1",
    "wah-heading-2": "[&>*]:wah-heading-2",
    "wah-heading-3": "[&>*]:wah-heading-3",
    "wah-heading-4": "[&>*]:wah-heading-4",
    "wah-heading-5": "[&>*]:wah-heading-5",
    "wah-heading-6": "!wah-heading-6",
    "wah-body-large": "[&>*]:wah-body-large",
    "wah-body-base": "[&>*]:wah-body-base",
    "wah-body-small": "[&>*]:wah-body-small",
    "wah-body-xsmall": "[&>*]:wah-body-xsmall",
  };
</script>

<div
  class={clsx(
    style.value === "prose-lg"
      ? "prose-lg prose-headings:mb-2 prose-headings:mt-8 prose-p:text-body-base prose-p:mb-2 prose-h2:text-h2 prose-h3:text-wah-heading-3 prose-h4:text-wah-heading-4 prose-h5:text-wah-heading-5 prose-h6:text-wah-heading-6"
      : styles[style.value],
    "[&>p]:mb-6 prose-a:underline",
  )}
  style={`color: ${color} `}
>
  {@html text}
</div>
